import { render, staticRenderFns } from "./SpacePageWrapper.vue?vue&type=template&id=49916bb4&scoped=true"
import script from "./SpacePageWrapper.vue?vue&type=script&lang=ts"
export * from "./SpacePageWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49916bb4",
  null
  
)

export default component.exports